export default "/images/eXPD8-UK-logo---No-whoosh---DG.png?bc142dde6a56c37f54f788f3f1c4824d";